//  document.querySelectorAll('.grid_cartBtn_iner').forEach(function (btnClick) {
//     btnClick.addEventListener('click', function() {
//         const siblingProduct = this.parentElement.querySelector('.product');
//         if (siblingProduct) {
//             siblingProduct.style.display = 'block';
//         }
//     });
// });
// document.querySelectorAll('.grid_cartBtn.product-form').forEach(function (btnBubale) {
//   btnBubale.addEventListener('click', function() {
//     document.querySelector('#upCart #UpcartPopup').classList.remove('upcartPopupShow');
//   });
// });


// document.querySelectorAll(".grid_cartBtn_iner").forEach(function(button) {

//   button.addEventListener("click", function () {

//     var parent = this.closest(".grid_cartBtn");

//     var product = parent.querySelector(".product");

//     var id = product.getAttribute("data-variant-id");

//     var qty = 1;
 
//     fetch('/cart/add.js', {

//       method: 'POST',

//       headers: {

//         'Content-Type': 'application/json'

//       },

//       body: JSON.stringify({

//         id: id,

//         quantity: qty

//       })

//     })

//     .then(function(response) {

//       if (!response.ok) {

//         throw new Error("Network response was not ok");

//       }

//       return response.json();

//     })

//     .then(function(data) {

//       console.log("add");

//     })

//     .catch(function(error) {

//       console.log("not add");

//     });

//   });

// });


document.addEventListener("DOMContentLoaded", function () {
  const productCards = document.querySelectorAll(".sliderGrid_grid_row .product-card");
  const container = document.querySelector(".sliderGrid_grid_row");
  const showMoreContainer = document.getElementById("showMoreButtonContainer");
  let currentIndex = 4; 
  const batchSize = 4;
  let isLoading = false;

  // Initially show the first 4 cards
  productCards.forEach((card, index) => {
    card.style.display = index < currentIndex ? "block" : "none";
  });

  function showNextBatch() {
    const nextIndex = Math.min(currentIndex + batchSize, productCards.length);
    for (let i = currentIndex; i < nextIndex; i++) {
      productCards[i].style.display = "block";
    }
    currentIndex = nextIndex;
    isLoading = false;
  }

  function isNearViewportBottom() {
    const rect = container.getBoundingClientRect();
    return rect.bottom <= (window.innerHeight + 50);
  }

  window.addEventListener("scroll", function () {
    if (isNearViewportBottom() && !isLoading && currentIndex < productCards.length) {
      isLoading = true;
      showMoreContainer.style.display = 'block';

      setTimeout(function () {
        showMoreContainer.style.display = 'none';
        showNextBatch();
      }, 2000);
    }
  });
});

